<div class="dialog kultur-nav-importer-dialog">
  <div
    mat-dialog-title
    class="modal-header"
  >
    <h1 class="modal-title">
      <span>
        {{ 'TRANS__CULTURE_HUB_IMPORTER__TITLE' | translate }}
      </span>
    </h1>

    <button
      type="button"
      mat-icon-button
      class="close"
      [tabindex]="-1"
      aria-label="close dialog"
      mat-dialog-close=""
    >
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>

  <mat-tab-group color="accent">
    <mat-tab label="{{'TRANS__CULTURE_HUB_IMPORTER__SINGLE_CONCEPTS' | translate}}">
      @if (kulturNavData) {
        <app-kultur-nav-importer-items
          [dialogRef]="dialogRef"
          [kulturNavData]="kulturNavData">
        </app-kultur-nav-importer-items>
      }
    </mat-tab>
    <mat-tab label="{{'TRANS__CULTURE_HUB_IMPORTER__FOLDERS' | translate}}">
      @if (kulturNavData) {
        <app-kultur-nav-importer-folders
          [dialogRef]="dialogRef"
          [kulturNavData]="kulturNavData">
        </app-kultur-nav-importer-folders>
      }
    </mat-tab>
  </mat-tab-group>
</div>
